export const UserView = 'user';
